module.exports = __webpack_public_path__ + "static/media/4-mobile.8eb163e4.jpg";